/**
 * Sentry project IDs per dashboard tab.
 * Each dashboard uses a separate Sentry project for tracking issues.
 */
export const SENTRY_PROJECT_APEX_CLIENT = '4507465295659008'
export const SENTRY_PROJECT_DISPATCH_MOBILE = '4508858067189760'
export const SENTRY_PROJECT_DOCK_AUTOMATION = '4507612907438080'
export const SENTRY_PROJECT_CLOUD_WATCH = '4507465295659008'

export function isApexClientProject(projectId: string): boolean {
  return projectId === SENTRY_PROJECT_APEX_CLIENT
}

export function isDispatchMobileProject(projectId: string): boolean {
  return projectId === SENTRY_PROJECT_DISPATCH_MOBILE
}

export function isDockAutomationProject(projectId: string): boolean {
  return projectId === SENTRY_PROJECT_DOCK_AUTOMATION
}

export function isCloudWatchProject(projectId: string): boolean {
  return projectId === SENTRY_PROJECT_CLOUD_WATCH
}
